import React from "react";
import FeatureFlagProvider from "~/common/contexts/FeatureFlagProvider";
import ProductListing from "../ProductListing";
import YouMayAlsoNeedHeader from "./YouMayAlsoNeedHeader";
import { YouMayAlsoNeedPageResult } from "./YouMayAlsoNeedPageResult";

const YouMayAlsoNeedPage = ({
  featureFlags,
  facetNavigation,
  headerText,
  pagination,
  productLink,
  products,
  rawClientUrl,
}: YouMayAlsoNeedPageResult) => {
  return (
    <FeatureFlagProvider featureFlags={featureFlags}>
      <div data-module="initYouMayAlsoNeedPage">
        <ProductListing
          aboveChromeComponent={
            <YouMayAlsoNeedHeader
              headerText={headerText}
              productLink={productLink}
            />
          }
          facetNavigation={facetNavigation}
          hasBackground={false}
          hasHeaderData={false}
          hideFilters={false}
          hideTopper
          pageName={headerText}
          pageUrl={rawClientUrl}
          pagination={pagination}
          products={products}
        />
      </div>
    </FeatureFlagProvider>
  );
};

export default YouMayAlsoNeedPage;
